var map = {
	"./Auth/ChangePassword": 8236,
	"./Auth/ChangePassword.vue": 8236,
	"./Auth/Login": 1354,
	"./Auth/Login.vue": 1354,
	"./Campaign/Create": 1410,
	"./Campaign/Create.vue": 1410,
	"./Campaign/Edit": 4189,
	"./Campaign/Edit.vue": 4189,
	"./Campaign/Index": 9422,
	"./Campaign/Index.vue": 9422,
	"./Channel/Create": 7272,
	"./Channel/Create.vue": 7272,
	"./Channel/Edit": 5382,
	"./Channel/Edit.vue": 5382,
	"./Channel/Index": 8764,
	"./Channel/Index.vue": 8764,
	"./Contacts/Create": 1144,
	"./Contacts/Create.vue": 1144,
	"./Contacts/Edit": 7714,
	"./Contacts/Edit.vue": 7714,
	"./Contacts/Index": 1186,
	"./Contacts/Index.vue": 1186,
	"./Custmanagement/Create": 9361,
	"./Custmanagement/Create.vue": 9361,
	"./Custmanagement/Index": 7165,
	"./Custmanagement/Index.vue": 7165,
	"./Dashboard/Index": 9876,
	"./Dashboard/Index.vue": 9876,
	"./Organizations/Create": 1527,
	"./Organizations/Create.vue": 1527,
	"./Organizations/Edit": 9792,
	"./Organizations/Edit.vue": 9792,
	"./Organizations/Index": 1241,
	"./Organizations/Index.vue": 1241,
	"./PendingSubmission/Index": 7524,
	"./PendingSubmission/Index.vue": 7524,
	"./Reports/Index": 8576,
	"./Reports/Index.vue": 8576,
	"./Submission/Create": 7120,
	"./Submission/Create.vue": 7120,
	"./Submission/Index": 4416,
	"./Submission/Index.vue": 4416,
	"./Users/Create": 9305,
	"./Users/Create.vue": 9305,
	"./Users/Edit": 9575,
	"./Users/Edit.vue": 9575,
	"./Users/Index": 4698,
	"./Users/Index.vue": 4698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;